import gql from 'graphql-tag';

export default gql`
  fragment DataEntryData on DataEntryData {
    entryUuid
    data
    customName
  }
`;
